import { Input, Table, TableColumnsType } from "antd";
import moment from "moment";
import { Link } from "react-router-dom";
import { RouteName } from "constants/route";
import AddIcon from "components/Icons/AddIcon";
import Action from "./components/Action";
import { IPlace } from "models/place";
import usePlace from "hooks/usePlace";
import { PlaceAlertContextProvider } from "./components/AlertContext";
import NextIcon from "components/Icons/NextIcon";
import PreviousIcon from "components/Icons/PreviousIcon";
import { SearchOutlined } from "@ant-design/icons";
import { FaLocationPin } from "react-icons/fa6";

export default function Place() {
  const {
    data: { data, loading, page, per_page, total, search },
    handlePageChange,
    handleSearch,
  } = usePlace();

  return (
    <PlaceAlertContextProvider>
      <div className="w-full">
        <div className="w-full px-6 flex flex-wrap-reverse">
          <div className="grow justify-between items-center flex-wrap-reverse gap-5">
            <div className="flex flex-col">
              <Link
                to={RouteName.CREATE_PLACE}
                className="flex items-center p-3 border rounded-lg border-black w-fit gap-x-2"
              >
                <AddIcon />
                <span className="text-black text-sm font-medium">
                  Add Place
                </span>
              </Link>
            </div>
          </div>
          <Input
            className="max-w-72 w-full h-auto px-4 py-2 text-base border border-[rgb(0,0,0,0.1)] rounded-3xl"
            prefix={<SearchOutlined className="mr-2" />}
            placeholder="Search..."
            onChange={handleSearch}
            value={search}
          />
        </div>
        <div className="flex w-full justify-end items-center pt-6 px-6">
          <Link
            to={RouteName.VIEW_PLACES_ON_MAP}
            className="flex items-center p-3 w-fit gap-x-2"
          >
            <FaLocationPin />
            <span className="text-black text-sm font-medium">View on Map</span>
          </Link>
        </div>
        <div className="w-full mt-2 px-4">
          <Table
            loading={loading}
            columns={columns}
            dataSource={data}
            onChange={handlePageChange}
            pagination={{
              total,
              pageSize: per_page,
              current: page,
              nextIcon: (
                <span className="flex items-center justify-center w-8 h-8 text-2xl">
                  <NextIcon />
                </span>
              ),
              prevIcon: (
                <span className="flex items-center justify-center w-8 h-8 text-2xl">
                  <PreviousIcon />
                </span>
              ),
            }}
          />
        </div>
      </div>
    </PlaceAlertContextProvider>
  );
}

const columns: TableColumnsType<IPlace> = [
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Latitude",
    dataIndex: "latitude",
  },
  {
    title: "Longitude",
    dataIndex: "longitude",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    render: (createdAt) => <p>{moment(createdAt).format("lll")}</p>,
  },
  {
    title: "Action",
    render: (value: IPlace) => <Action place={value} />,
  },
];
